import { Modal } from "antd";
import { ReactNode } from "react";

interface ConfirmationModalProps {
  children: ReactNode
  isOpen: boolean
  title: string;
  description: string;
  openCallback: (open: boolean) => void
  confirmCallback: () => void
}

const ConfirmationModal = ({ isOpen, title, description, openCallback, confirmCallback, children }: ConfirmationModalProps) => {

  const handleOk = () => {
    confirmCallback()
    openCallback(false);
  };

  const handleCancel = () => {
    openCallback(false);
  };

  return (
    <>
    {children}
    <Modal
      title={title}
      closable={{ 'aria-label': 'Close Button' }}
      open={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <p>{description}</p>
    </Modal>
    </>
  )
}

export default ConfirmationModal